module.exports = __webpack_public_path__ + "static/media/MainPage_1.dd21de06.png";